import { mutationTypes, actionTypes } from 'BASE/store/types';
import userinfoStore from 'BASE/store/userInfo/userInfo.store';
import lottoinfoStore from 'BASE/store/bet/bet.store.lottogame';
import signalr from 'BASE/common/signalrAdapter';

export default {
    data: function () {
        return {
            CountdownTimer: null,
        };
    },
    methods: {
        async updateWalletAmount() {
            await this.$store.dispatch(actionTypes.USER_INFO_WALLET_AMOUNT);
        }
    },
    async mounted() {
        let _this = this;
        //如有收到變更權限就通知store變更
        signalr.addWorkOnConnected(() => {
            signalr.userInfoPrivilegesClient.userInfoPrivileges.addHandler(input => {
                _this.$store.dispatch(actionTypes.USER_INFO_PRIVILEGES);
                _this.$store.dispatch(actionTypes.USER_INFO_PRIVILEGES_BONUS);
            });
        });
        this.$store.dispatch(actionTypes.USER_INFO_INIT);
        await this.$store.dispatch(actionTypes.USER_INFO_MERCHANT_CODE);
        await this.$store.dispatch(actionTypes.CHAT_INFO);
        await this.$store.dispatch(actionTypes.USER_INFO_PRIVILEGES);
        await this.$store.dispatch(actionTypes.USER_INFO_PRIVILEGES_BONUS);
        await this.$store.dispatch(actionTypes.USER_INFO_REGISTER_LINK_CODE);
        await this.$store.dispatch(actionTypes.USER_INFO_DEMO_LINK); //試玩
        await this.$store.dispatch(actionTypes.USER_INFO_IS_WECHAT_ENABLED);
        await this.$store.dispatch(actionTypes.LOTTOGAME_DATA);
        await this.$store.dispatch(actionTypes.USER_INFO_GET_BASE_DATA);
        await this.$store.dispatch(actionTypes.USER_INFO_ALERTS);
        await this.$store.dispatch(actionTypes.VIP_INFO);
        await this.updateWalletAmount();

        this.$store.commit(mutationTypes.USER_INFO_INITIALIZED, { initialized: true });
        this.CountdownTimer = setInterval(this.updateWalletAmount, 10000); //預設每10秒刷新一次
    },
    beforeDestroy() {
        clearInterval(this.CountdownTimer);
        this.$store.unregisterModule('userinfo');
        this.$store.unregisterModule('lottoinfo');

        if (signalr.isInitialized) {
            signalr.userInfoPrivilegesClient.userInfoPrivileges.clearHandler();
        }
    },
    beforeCreate() {
        this.$store.registerModule('userinfo', new userinfoStore());
        this.$store.registerModule('lottoinfo', new lottoinfoStore());
    },
}